import { axios } from 'api'
import PlaylistDetailsPage from 'components_v1/pageLevelComponents/playlists/PlaylistDetailsPage'
import { useCommonEntryContext, CURRENT_URL } from 'components_v2/common'
import { flattenMeta, useMeta, useTitle } from 'hooks/useMetaTitle'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

const Main = styled.div``
const PlaylistDetailsView = () => {
  const { slug } = useParams()
  const { user, searchParams } = useCommonEntryContext()
  const source = searchParams?.get('source')
  const username = user?.username
  const [playlist, setPlaylist] = useState()
  useTitle(playlist?.title)
  useMeta(
    flattenMeta({
      og: {
        title: playlist?.title,
        description: playlist?.description,
        url: CURRENT_URL,
        image: [
          {
            _: playlist?.coverPhoto?.url || '',
            width: 320,
            height: 180
          }
        ]
      }
    })
  )
  useEffect(() => {
    axios
      .get(`/playlists/${slug}`, { load: true })
      .then((res) => setPlaylist(res.data))
      .catch((err) => {
        console.log(err)
        window.location.href = '/signin'
      })
  }, [slug])

  if (!playlist) return null
  return (
    <Main className='playlist-container'>
      <div className='section-items-container'>
        <PlaylistDetailsPage
          playlistObj={playlist}
          userIsAuthor={playlist?.author?.username === username}
          signedIn={Boolean(username)}
          source={source}
          membershipTier={user?.membershipTier}
          totalItems={playlist?.entryCount}
        />
      </div>
    </Main>
  )
}

export default PlaylistDetailsView
